import JSONBig from "json-bigint";
const JB = JSONBig({ useNativeBigInt: true });

export const JSONbigParse = JB.parse;
export const JSONbigStringify = JB.stringify;
